import React from 'react';
import { createBrowserRouter, Navigate, RouterProvider } from 'react-router-dom';
import HomePage from '../Routes/HomePage';
import HomePage2 from '../Routes/HomePage2';
import SubscriptionProcessingPage from '../Routes/SubscriptionProcessingPage';
import OtpPage from '../Routes/OtpPage';
import SubscribePage from '../Routes/SubscribePage';
import LoginPage from '../Routes/LoginPage';
import Auth from '../Components/Auth';

const Routing = () => {
  const router = createBrowserRouter([
    {
      path: "/",
      element: <SubscribePage />
    },
    {
      path: "/otp",
      element: <OtpPage />
    },
    {
      path: "/subscription-processing",
      element: <SubscriptionProcessingPage />,
    },
    {
      path: "/login",
      element: <LoginPage />
    },
    {
      path: "/home",
      element:
        <Auth>
          <HomePage2 />
        </Auth>
    },
    {
      path: "*",
      element: <Navigate to="/" />
    }
  ])
  return (
    <RouterProvider router={router} />
  )
}

export default Routing